module.exports = __webpack_public_path__ + "src/images/personal-portfolio.c9e39e2938e2b33fbc64944b98b602e6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/personal-portfolio.jpg
// module id = 121
// module chunks = 0